import { render, staticRenderFns } from "./PhysicalCard.vue?vue&type=template&id=ee16e5f8&scoped=true"
import script from "./PhysicalCard.vue?vue&type=script&lang=js"
export * from "./PhysicalCard.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCard.vue?vue&type=style&index=0&id=ee16e5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee16e5f8",
  null
  
)

export default component.exports